import {
  IFloatingFilterParams,
  ITextFilterParams,
  TextFilterModel,
} from '@ag-grid-community/core';
import { TextField } from '@atgfr8/atg-ui-tailwind';
import { CloseIcon } from '@atgfr8/icons';
import { debounce } from 'lodash';
import { createSignal, onCleanup, onMount } from 'solid-js';

interface ParentTextFilter extends ITextFilterParams {
  onFloatingFilterChanged(type: string | null, text: string | null): void;
  getModel(): TextFilterModel | null;
}

export const CustomTextFloatingFilter = (props: IFloatingFilterParams) => {
  const [text, setText] = createSignal('');

  const applyFilter = (value: string | null) => {
    props.parentFilterInstance((instance: ParentTextFilter) => {
      if (!value?.trim()) {
        instance.onFloatingFilterChanged(null, null);
      } else {
        instance.onFloatingFilterChanged('contains', value);
      }
    });
  };

  const debouncedApplyFilter = debounce(applyFilter, 500);

  const onTextChange = (e: string) => {
    setText(e);
    debouncedApplyFilter(e);
  };

  const clearFilter = () => {
    setText('');
    debouncedApplyFilter.cancel();
    applyFilter(null);
  };

  onMount(() => {
    const onFilterChanged = () => {
      props.parentFilterInstance((instance: ParentTextFilter) => {
        const model = instance.getModel();
        if (!model || (model.filter == null && !model.type)) {
          setText('');
        }
      });
    };

    props.api.addEventListener('filterChanged', onFilterChanged);

    onCleanup(() => {
      props.api.removeEventListener('filterChanged', onFilterChanged);
      debouncedApplyFilter.cancel();
    });
  });

  return (
    <div class="flex items-center gap-1 px-1">
      <TextField
        value={text()}
        onChange={(e) => onTextChange(e)}
        dataTestId="dormant-pool-floating-filter-input"
        class="grow h-[22px]! min-h-[22px]! [&>input]:h-[22px]! [&>input]:p-[0 6px]! [&>input]:text-sm! [&>input]:font-medium!"
      />
      {text().trim() && (
        <CloseIcon
          class="cursor-pointer text-gray-500 hover:text-red-500"
          onClick={clearFilter}
          aria-label="Clear Filter"
          size={20}
        />
      )}
    </div>
  );
};
